export default __webpack_public_path__ + "static/media/mw-permissions-icon.dc39d31b.svg";